<template>
  <div class="bg-gray-900 rounded-2xl shadow-xl overflow-hidden">
    <div class="px-6 py-4 border-b border-gray-700 flex items-center justify-between">
      <div class="flex items-center space-x-3">
        <svg class="h-5 w-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
        </svg>
        <span class="text-white font-semibold">{{ title || `${language} Code` }}</span>
      </div>
      <div class="flex items-center space-x-3">
        <span class="text-xs text-gray-500 uppercase tracking-wide">{{ language }}</span>
        <button
          @click="handleCopy"
          class="flex items-center space-x-2 px-3 py-1.5 bg-gray-800 hover:bg-gray-700 text-gray-300 rounded-lg transition-all text-sm"
        >
          <svg v-if="copied" class="h-4 w-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          <svg v-else class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
          <span>{{ copied ? 'Copied!' : 'Copy' }}</span>
        </button>
      </div>
    </div>
    <div class="p-6">
      <pre class="text-sm text-gray-300 overflow-x-auto"><code :class="`language-${language}`">{{ code }}</code></pre>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  code: {
    type: String,
    required: true
  },
  language: {
    type: String,
    required: true
  },
  title: {
    type: String,
    default: ''
  }
});

const copied = ref(false);

const handleCopy = async () => {
  await navigator.clipboard.writeText(props.code);
  copied.value = true;
  setTimeout(() => {
    copied.value = false;
  }, 2000);
};
</script>
